import { MenuItem, Select } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";
import "./styles.css";

type Option = { value: string; label: string };

type Props = {
    value: string;
    onChange: (value: string) => void;
    options: Option[];
    placeholder?: string;
    disabled?: boolean;
};

export default function SelectInput({ value, onChange, options, placeholder, disabled }: Props) {
    const handleChange = (e: SelectChangeEvent) => onChange(e.target.value);

    return (
        <Select
            className="select-input"
            value={value}
            onChange={handleChange}
            displayEmpty
            disabled={disabled}
            fullWidth
            renderValue={(selected) => {
                if (!selected) return <span className="select-input-placeholder">{placeholder}</span>;
                return options.find((o) => o.value === selected)?.label ?? selected;
            }}
            MenuProps={{ slotProps: { paper: { className: "select-input-paper" } } }}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );
}
